/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente WrapColorPicker
 */
export const WrapColorPicker = styled.div`
  .style-list {
    height: 30px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    padding: 0px 0px 20px;
    .disabled-item {
      svg path {
        fill: #aeaeae;
        fill-opacity: 1;
        stroke: #aeaeae;
      }
    }
    .style-item {
      position: relative;
      width: 26px;
      height: 26px;
      display: flex;
      justify-content: center;
      align-items: center;

      svg {
        width: 22px;
        height: 22px;
        transition: width 200ms, height 200ms;
      }
      &:hover {
        svg {
          width: 26px;
          height: 26px;
        }
      }
      .selected-style {
        position: absolute;
        top: calc(50% - 12.5px);
        left: calc(50% - 12.5px);
        color: green;
        svg {
          width: 25px;
          height: 25px;
        }
      }
    }
  }
`;
